import { createContext } from "react";

import type { ChromeVisibilityContextValue } from "./chromeTypes";

export const ChromeVisibilityContext =
  createContext<ChromeVisibilityContextValue | null>(null);
ChromeVisibilityContext.displayName = "ChromeVisibilityContext";
